import React from 'react';
import Pagination from 'react-js-pagination';
import {PayPalGroup as PPG} from 'FW/Models/PayPalGroup';
import PayPalItem from './PayPalItem';
import LoadingWheel from '../MediaLibrary/LoadingWheel';
import './paypal.scss';

class PayPalGroup extends React.Component {
  constructor(props) {
    super(...arguments);
    let group = FW.store.get(
      'section-' + props.section.get('id') + '-paypal-group'
    );
    this.state = {
      section: props.section,
      group: group,
      items: group.get('paypal_items'),
      filters: {},
      activePage: 1,
      lastPageSize: this.getPageSize(),
      groupID: group.get('id')
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    props.section.on(
      'reboot',
      () => {
        let items = this.state.group.get('paypal_items');
        items.resetSearch();
        items.setPageSize(this.getPageSize(), () => {
          items.trigger('sync');
          this.setState({
            activePage: items.pagination ? items.pagination.number : 1,
            loading: false
          });
        });
      },
      this
    );
  }

  getPageSize() {
    return this.props.section.prop('paypal_group_options')
      ? this.props.section.prop('paypal_group_options').items_per_page || 15
      : 15;
  }

  componentDidMount() {
    let items = this.state.group.get('paypal_items');
    let pageSize = this.getPageSize();
    items.on(
      'sync',
      () => {
        this.setState({
          items: items,
          loading: false
        });
      },
      this
    );
    items.setPageSize(pageSize);
    this.addItemListeners(items);
    if (!this.state.group.get('created_at')) {
      this.setState({
        groupNotFound: true
      });
    }
    items.on('error', (items, e) => {
      if (e.status === 404) {
        this.setState({
          groupNotFound: true
        });
      }
    });
  }

  // addButtonToSection() {
  //   let section = this.props.section;
  //   let user = window.parent.FW.store.get('user') ? window.parent.FW.store.get('user') : null;
  //   if (user) {
  //     section._editButtons = [{
  //       title: 'Edit PayPal Item Group',
  //       class: 'glyphicon-pencil',
  //       type: 'btn-default',
  //       action: () => {
  //         this.editGroup();
  //       }
  //     }];
  //   }
  // }

  // editGroup() {
  //   window.parent.FW.editor.setMode('editPayPalGroup', 'editPayPalGroup', {
  //     group: this.state.group,
  //     remount: true,
  //     onSave: () => {
  //       this.props.section.reboot();
  //     }
  //   });
  // }

  componentDidUpdate() {
    let pageSize = this.getPageSize();
    let groupID = this.props.section.prop('group_id');
    let group = PPG.findOrCreate({id: groupID});
    if (pageSize !== this.state.lastPageSize) {
      let items = group.get('paypal_items');
      items.setPageSize(pageSize, () => {
        this.setState({
          loading: false,
          lastPageSize: pageSize
        });
      });
    }
    if (groupID !== this.state.groupID) {
      group
        .get('paypal_items')
        .fetch()
        .then(() => {
          this.forceUpdate();
        });
      this.setState({
        groupNotfound: false,
        loading: true,
        activePage: 1,
        groupID: groupID,
        group: group
      });
    }
  }

  addItemListeners(items) {
    items.off(null, null, this);
    items.on(
      'sync',
      () => {
        this.setState({
          items: items,
          loading: false
        });
      },
      this
    );
  }

  componentWillUnmount() {
    this.state.group.get('paypal_items').off(null, null, this);
    this.props.section.off(null, null, this);
  }

  handlePageChange(page) {
    this.setState({
      loading: true
    });
    let top = $(this.div).offset().top;
    let items = this.state.group.get('paypal_items');
    $('html, body').animate({scrollTop: top - 70 + 'px'}, 500);
    items.getPage(page, () => {
      this.setState({
        activePage: page,
        loading: false
      });
    });
  }

  render() {
    let items = this.state.group.get('paypal_items');
    let pagination = items ? items.pagination : {};
    const columns = 4;
    items = items
      ? items.getCurrentPage().map((item, i) => {
          const box = (
            <div key={item.get('id')} className={`col-md-${12 / columns} paypalStoreItem`}>
              <PayPalItem item={item} section={this.props.section} />
            </div>
          );
          if (i % 4 === 0)
            return [<div key={i + '-clearfix'} className="clearfix" style={{pointerEvents: 'none'}} />, box];
          return box;
        })
      : [];

    return (
      <div
        className="FWPayPalGroupSection standard-layout"
        ref={c => {
          this.div = c;
        }}
      >
        {this.state.groupNotFound ? (
          <div
            style={{
              paddingTop: 150,
              paddingBottom: 150,
              paddingLeft: 10,
              paddingRight: 10,
              textAlign: 'center',
              background: '#ccc',
              borderRadius: 5,
              marginLeft: 20,
              marginRight: 20
            }}
          >
            <p className="lead">PayPal Item Group Not Found</p>
            {FW.inEditor() ? (
              <p className="lead">
                You can edit this section&apos;s properties to select a PayPal
                item group.
              </p>
            ) : null}
          </div>
        ) : (
          <div>
            <div
              className="items paypalGroupContainer row"
              style={{position: 'relative', width: '100%'}}
            >
              {items}
              {this.state.activePage === 1 && items.length === 0 ? (
                <div style={{width: '100%', padding: 50, textAlign: 'center'}}>
                  <p className="lead">
                    This group does not yet have any items.
                  </p>
                  {FW.inEditor() ? (
                    <p className="lead" style={{fontSize: '1.2em'}}>
                      You can add items to this group by clicking on PayPal
                      Store in the Admin Panel.
                    </p>
                  ) : null}
                </div>
              ) : null}
              <div style={{textAlign: 'center', width: '100%'}}>
                <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={pagination.size || 10}
                  totalItemsCount={pagination.total || 10}
                  pageRangeDisplayed={15}
                  innerClass={'pagination col-md-12 paypalPagination'}
                  onChange={this.handlePageChange}
                />
              </div>

              {this.state.loading ? (
                <div
                  style={{
                    position: 'absolute',
                    width: 'calc(100% - 20px)',
                    height: 'calc(100% - 20px)',
                    margin: '10px',
                    background: 'rgba(93, 93, 93, 0.61)',
                    borderRadius: '5px'
                  }}
                >
                  <LoadingWheel style={{top: 100}} />
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default PayPalGroup;
